import * as React from "react";
import AppTable from "../tables/AppTable";
import {
  Fab,
  Typography,
  CircularProgress,
  Alert,
  Box,
  Pagination,
  Stack,
} from "@mui/material";
import AddToPhotosOutlinedIcon from "@mui/icons-material/AddToPhotosOutlined";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";


function UsersView() {
  const { token } = React.useContext(AuthContext) || {};
  const [users, setUsers] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
  });

  const fetchUsers = async (page, perPage) => {
    setLoading(true);
    try {
      let options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await fetch(
        `/api/users?page=${page}&per_page=${perPage}`,
        options
      );

      const data = await response.json();

      if (response.ok) {
        setUsers(data.data);
        setPagination((prev) => ({
          ...prev,
          totalPages: data.pagination.total_pages,
        }));
        setError(null);
      } else {
        setError("Error fetching users");
      }
    } catch (err) {
      setError("Error fetching users");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
  };

  React.useEffect(() => {
    if(token) {
      fetchUsers(pagination.currentPage, pagination.perPage);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, pagination.perPage, token]);

  const navigate = useNavigate();

  const handleAddUserClick = () => {
    navigate("/admin/users/createUser");
  };

  return (
    <>
      {!loading ? (
        <>
          <Fab
            color="primary"
            variant="extended"
            sx={{
              mr: 1,
              mb: {
                xs: 1,
                sm: 0,
                lg: 0,
              },
              ml: 2,
            }}
            onClick={handleAddUserClick}
          >
            <AddToPhotosOutlinedIcon />
            <Typography
              sx={{
                ml: 1,
                textTransform: "capitalize",
              }}
            >
              {"Añadir nuevo"}
            </Typography>
          </Fab>

          {error && (
            <Alert
              sx={{
                mx: "auto",
                my: 2,
                width: "95%",
              }}
              severity="error"
            >
              {error}
            </Alert>
          )}

          {users.length > 0 ? (
            <Box>
              <AppTable data={users} />
              <Stack spacing={2} alignItems="center" sx={{ marginTop: 2 }}>
                <Pagination
                  count={pagination.totalPages}
                  page={pagination.currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                />
              </Stack>
            </Box>
          ) : (
            <Alert severity="info">No users found.</Alert>
          )}
        </>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
}

export default UsersView;
